export class ProjectNotFound extends Error {}
